import * as React from "react";
import { AutoCompleteInput, Input, Label } from "uxp/components";
import { findAvailableFields, IUIPropertyDefinition } from '../common';
import { WidgetDesignerPillInput } from "../pill-input/PillInput";
import { Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "./common";
import { bindContainerId } from "../../../util";
import { IContextSchemaProps } from "../../../hooks/useContextData";

export function SimpleTextProperty(title: string, props: string, showCategoryTitle = false, fieldId?: string, useAutoCompleteInput?: boolean, customContextValues?: IContextSchemaProps[]): IUIPropertyDefinition<string> {
    return {
        defaults: props,
        render: (props, uxpContext, contextData, containerId) => {

            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();

            return <PropertyContainer>
                <PropertyGroup>
                    {!!showCategoryTitle ? <PropertyGroupTitle>{title}</PropertyGroupTitle> : null}

                    <Property id={bindContainerId(fieldId || 'text', containerId)}>
                        <PropertyTitle>{title}</PropertyTitle>
                        {
                            useAutoCompleteInput
                                ? <AutoCompleteInput
                                    value={props.uiProps || ''}
                                    onChange={s => props.onChange(s)}
                                    className="widget-designer-input"
                                    options={pv}
                                />
                                : <WidgetDesignerPillInput
                                    value={props.uiProps || ''}
                                    onChange={s => props.onChange(s)}
                                    contextData={contextData}
                                    customContextValues={customContextValues}
                                />
                        }

                    </Property>
                </PropertyGroup>
            </PropertyContainer>
        }
    };
}